import React from 'react';
import cssClasses from './Spinner.css';
// import GridLoader from 'react-spinners/GridLoader';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';

const spinner = (props) => (
    <div className={cssClasses.Main}>
        <ClimbingBoxLoader
            sizeUnit={"px"}
            size={15}
            color='var(--green)'
            loading={props.loading}
        />
        <p>Loading..</p>
    </div>
)
export default spinner;